import { BaseRequest, IBaseRequest } from '../../BaseRequest';

export interface ListFilter{
    rangeStart:                     Date;
    rangeEnd:                       Date;
    userId?:                         string;
    anyTime?:                        string;
    standardStatus?:                 string;
    entryType?:                      string;
    activityId?:                     string;
    projectId?:                      string;
    folderId?:                       string;
    solutionStatus?:                 string;
    includePast?:                    string;
    userFilter?:                     string;
    dependend?:                      string;
    recordId?:                       string;
    referenceId?:                    string;
    approvalStatus?:                 string;
    limit?:                          number;
    offset?:                         number;
    countOnly?:                      string;
    orderBy1Desc?:                   string;
    orderBy1Field?:                  string;
    orderBy2Desc?:                   string;
    orderBy2Field?:                  string;
    orderBy3Desc?:                   string;
    orderBy3Field?:                  string;
    orderBy4Desc?:                   string;
    orderBy4Field?:                  string;
    dateOfInterest?:                 string;
    groupUsers?:                     string;
    multiUser?:                      string;
    dimension1?:                     string;
    dimension2?:                     string;
    dimension3?:                     string;
    dimension1Name?:                 string;
    dimension2Name?:                 string;
    dimension3Name?:                 string;
    garant?:                         string;
    plannedTaskCurrent?:             string;
    masterProjectResponsibleUserId?: string;
    masterProjectId?:                string;
    USERFILTER?:                     Userfilter[];
    IDFILTER?:                       Idfilter[];
    MASSCHANGE?:                     Masschange;
}

export interface Idfilter {
    id?: string;
}

export interface Masschange {
    changeChargeability?: string;
    chargeability?:       string;
    changeTypeOfWork?:    string;
    typeOfWorkId?:        string;
    changeContext?:       string;
    folderId?:            string;
    projectId?:           string;
    activityId?:          string;
    changeTitle?:         string;
    newTitle?:            string;
    changeDescription?:   string;
    newDescription?:      string;
    changeComment?:       string;
    newComment?:          string;
    addUser?:             string;
    addedUserId?:         string;
    removeUser?:          string;
    removedUserId?:       string;
    changeReminder?:      string;
    reminderTime?:        string;
    addNotify?:           string;
    addedNotifyId?:       string;
    removeNotify?:        string;
    removedNotifyId?:     string;
}

export interface Userfilter {
    id?:        string;
    asGarant?:  string;
    asCreator?: string;
}

export interface IListTaskRequest extends IBaseRequest {
    filter: ListFilter;
}

export class ListTaskRequest extends BaseRequest implements IListTaskRequest {
    public filter: ListFilter;
  constructor(server: string, session: string, filter: ListFilter) {
    super(server, session);
    this.filter = filter;
  }

  public toXml(): string {
    var parameters: string = super.toXml();

    parameters += this.makeNode(this.filter.rangeStart.toISOString(), 'rangeStart');
    parameters += this.makeNode(this.filter.rangeEnd.toISOString(), 'rangeEnd');
    parameters += this.makeNode(this.filter.userId, 'userId');
    parameters += this.makeNode(this.filter.anyTime, 'anyTime');
    parameters += this.makeNode(this.filter.standardStatus, 'standardStatus');
    parameters += this.makeNode(this.filter.entryType, 'entryType');
    parameters += this.makeNode(this.filter.activityId, 'activityId');
    parameters += this.makeNode(this.filter.projectId, 'projectId');
    parameters += this.makeNode(this.filter.folderId, 'folderId');
    parameters += this.makeNode(this.filter.solutionStatus, 'solutionStatus');
    parameters += this.makeNode(this.filter.includePast, 'includePast');
    parameters += this.makeNode(this.filter.userFilter, 'userFilter');
    parameters += this.makeNode(this.filter.dependend, 'dependend');
    parameters += this.makeNode(this.filter.recordId, 'recordId');
    parameters += this.makeNode(this.filter.referenceId, 'referenceId');
    parameters += this.makeNode(this.filter.approvalStatus, 'approvalStatus');
    parameters += this.makeNode(this.filter.limit, 'limit');
    parameters += this.makeNode(this.filter.offset, 'offset');
    parameters += this.makeNode(this.filter.countOnly, 'countOnly');
    parameters += this.makeNode(this.filter.orderBy1Desc, 'orderBy1Desc');
    parameters += this.makeNode(this.filter.orderBy1Field, 'orderBy1Field');
    parameters += this.makeNode(this.filter.orderBy2Desc, 'orderBy2Desc');
    parameters += this.makeNode(this.filter.orderBy2Field, 'orderBy2Field');
    parameters += this.makeNode(this.filter.orderBy3Desc, 'orderBy3Desc');
    parameters += this.makeNode(this.filter.orderBy3Field, 'orderBy3Field');
    parameters += this.makeNode(this.filter.orderBy4Desc, 'orderBy4Desc');
    parameters += this.makeNode(this.filter.orderBy4Field, 'orderBy4Field');
    parameters += this.makeNode(this.filter.dateOfInterest, 'dateOfInterest');
    parameters += this.makeNode(this.filter.groupUsers, 'groupUsers');
    parameters += this.makeNode(this.filter.multiUser, 'multiUser');
    parameters += this.makeNode(this.filter.dimension1, 'dimension1');
    parameters += this.makeNode(this.filter.dimension2, 'dimension2');
    parameters += this.makeNode(this.filter.dimension3, 'dimension3');
    parameters += this.makeNode(this.filter.dimension1Name, 'dimension1Name');
    parameters += this.makeNode(this.filter.dimension2Name, 'dimension2Name');
    parameters += this.makeNode(this.filter.dimension3Name, 'dimension3Name');
    parameters += this.makeNode(this.filter.garant, 'garant');
    parameters += this.makeNode(this.filter.plannedTaskCurrent, 'plannedTaskCurrent');
    parameters += this.makeNode(this.filter.masterProjectResponsibleUserId, 'masterProjectResponsibleUserId');
    parameters += this.makeNode(this.filter.masterProjectId, 'masterProjectId');

    if(this.filter.USERFILTER){
        parameters += this.makeNodeArray(this.filter.USERFILTER, (userFilter) => {
            return `<USERFILTER>${this.makeNode(userFilter.id, 'id') + this.makeNode(userFilter.asGarant, 'asGarant') + this.makeNode(userFilter.asCreator, 'asCreator')}</USERFILTER>`;
        }, '');
    }

    if(this.filter.IDFILTER){
        parameters += this.makeNodeArray(this.filter.IDFILTER, (idFilter) => {
            return `<IDFILTER>${this.makeNode(idFilter.id, 'id')}</IDFILTER>`;
        }, '');
    }

    if(this.filter.MASSCHANGE){
        parameters += `<MASSCHANGE>`;

        parameters += this.makeNode(this.filter.MASSCHANGE.changeChargeability, 'changeChargeability');
        parameters += this.makeNode(this.filter.MASSCHANGE.chargeability, 'chargeability');
        parameters += this.makeNode(this.filter.MASSCHANGE.changeTypeOfWork, 'changeTypeOfWork');
        parameters += this.makeNode(this.filter.MASSCHANGE.typeOfWorkId, 'typeOfWorkId');
        parameters += this.makeNode(this.filter.MASSCHANGE.changeContext, 'changeContext');
        parameters += this.makeNode(this.filter.MASSCHANGE.folderId, 'folderId');
        parameters += this.makeNode(this.filter.MASSCHANGE.projectId, 'projectId');
        parameters += this.makeNode(this.filter.MASSCHANGE.activityId, 'activityId');
        parameters += this.makeNode(this.filter.MASSCHANGE.changeTitle, 'changeTitle');
        parameters += this.makeNode(this.filter.MASSCHANGE.newTitle, 'newTitle');
        parameters += this.makeNode(this.filter.MASSCHANGE.changeDescription, 'changeDescription');
        parameters += this.makeNode(this.filter.MASSCHANGE.newDescription, 'newDescription');
        parameters += this.makeNode(this.filter.MASSCHANGE.changeComment, 'changeComment');
        parameters += this.makeNode(this.filter.MASSCHANGE.newComment, 'newComment');
        parameters += this.makeNode(this.filter.MASSCHANGE.addUser, 'addUser');
        parameters += this.makeNode(this.filter.MASSCHANGE.addedUserId, 'addedUserId');
        parameters += this.makeNode(this.filter.MASSCHANGE.removeUser, 'removeUser');
        parameters += this.makeNode(this.filter.MASSCHANGE.removedUserId, 'removedUserId');
        parameters += this.makeNode(this.filter.MASSCHANGE.changeReminder, 'changeReminder');
        parameters += this.makeNode(this.filter.MASSCHANGE.reminderTime, 'reminderTime');
        parameters += this.makeNode(this.filter.MASSCHANGE.addNotify, 'addNotify');
        parameters += this.makeNode(this.filter.MASSCHANGE.addedNotifyId, 'addedNotifyId');
        parameters += this.makeNode(this.filter.MASSCHANGE.removeNotify, 'removeNotify');
        parameters += this.makeNode(this.filter.MASSCHANGE.removedNotifyId, 'removedNotifyId');

        parameters += `</MASSCHANGE>`;
    }

    return super.wrapperXml('ListTask', parameters);
  }
}
